import React, { useState, useEffect } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
// import moment from "moment";
import "./styles/RolesTableBody.css";
import {
  TableBody,
  TableRow,
  Tooltip,
  Switch
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { addorModifyRolesRequestCall } from "../../../../../../redux/actions/adminAccount-actions/roles-action/rolesRequest-action";
import { useDispatch } from "react-redux";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#f9ccb5",
    color: theme.palette.common.black,
    fontWeight: 600,
    fontSize: 12,
    borderRight: "1px solid #80808040",
    borderBottom: "0px",
    padding: 3
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    color: "black",
    fontWeight: 400,
    borderRight: "1px solid #80808040",
    borderBottom: "0px",
    padding: 3
  }
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "rgb(0 255 205 / 4%)"
  }
}));

const RolesTableBody = ({
    setMode,
    setModalMessage,
    setIsModalOpen,
    setActiveModalNotice,
    setSelectedRole,
    setIsError,
    setTwoButton,
    rows,
    columns
}) => {

    const dispatch = useDispatch();
    const [localRows, setLocalRows] = useState([]);    

    useEffect(() => {
        setLocalRows(rows);
    }, [rows]);

    const editActionHandler = (row) => {
        setSelectedRole(row);
        setIsModalOpen(true);
        setMode("edit");
        setActiveModalNotice("addUpdate");
    };

    const deleteActionHandler = (row) => {
        setSelectedRole(row);
        setIsModalOpen(true);
        setMode("delete");
        setActiveModalNotice("message");
        setIsError(true);
        setTwoButton(true);
        setModalMessage([`"${row.name}"`, `Are you sure you want to delete this role ?`]);
    };

    const handleToggle = (index,row) => {
    console.log("Toggled index:", index,row,row['vamRoleId']);
    let payload;
    payload = {
        isActive: !localRows[index].isActive
    };
    dispatch(addorModifyRolesRequestCall("edit", payload, row['vamRoleId']));
    // const updatedRows = [...localRows];
    // updatedRows[index].isActive = !updatedRows[index].isActive;
    // setLocalRows(updatedRows);
    };        

    return (
        <TableBody>
            {localRows.length > 0 ?
                localRows.map((row, idx) => {
                    return (
                        <StyledTableRow key={idx}>                     
                            {columns.map((column) => {
                                if (column.accessor === "isActive") {
                                const isActive = row[column.accessor];                                
                                return (
                                <StyledTableCell key={column.accessor} className="roles_tableCell">
                                <Tooltip title={isActive ? "Click to Deactivate" : "Click to Activate"}>
                                    <Switch
                                        checked={isActive}
                                        onChange={() => handleToggle(idx,row)}
                                        sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                      color: 'green'
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                      backgroundColor: 'lightGreen'
                                    },
                                    '& .MuiSwitch-switchBase': {
                                      color: 'red'
                                    }, '& .MuiSwitch-track': {
                                      backgroundColor: '#FF7276'
                                    }
                                  }}
                                  />
                                </Tooltip>
                                </StyledTableCell>
                                );
                            }

                            if (column.accessor === "isElevatedRole") {
                                return (
                                    <StyledTableCell key={column.accessor} className="roles_tableCell">
                                        {row[column.accessor] ? "Yes" : "No"}
                                    </StyledTableCell>
                                );
                            }

                            if (column.actionable){
                                return (
                                    <StyledTableCell key={column.accessor} className="roles_tableCell">
                                        <div className="roles_actionIconGroup">
                                            <span>
                                                <EditOutlinedIcon
                                                    className="roles_actionIconGroupIcon"
                                                    onClick={() => editActionHandler(row)}
                                                />
                                            </span>
                                            <span>
                                                <DeleteForeverOutlinedIcon
                                                    className="roles_actionIconGroupIcon"
                                                    onClick={() => deleteActionHandler(row)}
                                                />
                                            </span>
                                        </div>
                                    </StyledTableCell>
                                );
                            }
                            
                            return (
                            <StyledTableCell key={column.accessor} className="roles_tableCell">
                                {row[column.accessor]}
                            </StyledTableCell>
                            );
                            })}
                        </StyledTableRow>  
                    );})
                 : (<StyledTableRow key={"noRecordsFound"}>
                    <StyledTableCell colSpan={9} style={{
                    textAlign: "center"}}>
                        No records found!
                    </StyledTableCell></StyledTableRow>)}
         </TableBody>
    );
};

export default RolesTableBody;